import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ContractDto} from "../../../../../model/dto/entity/contract.dto";
import {ActivatedRoute} from "@angular/router";
import {WfProcessService} from "../../../../../../../feature-core/wf/service/api/wf-process.service";
import {
    ObjectBaseModeComponent
} from "../../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {MvsObjectCount} from "../../../../../../../core/shared/workflow/component/mvs-workflow/mvs-workflow.component";
import {FilterCriteria} from "../../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../../../core/shared/dto/object/request/object-request-list";
import {DtoImportObjectContext} from "../../../../../../../core/shared/dto/dto.import.object.context";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";
import {ObserverService} from "../../../../../../../core/shared/object/service/observer.service";
import {MvsObjectNavigationService} from "../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {
    MvsObjectNavigationProviderGeneric
} from "../../../../../../../core/shared/navigation/impl/mvs-object-navigation-provider-generic";
import {Observable} from "rxjs";
import {ObjectRequestComplex} from "../../../../../../../core/shared/dto/object/request/object-request-complex";
import {
    ObjectRequestComplexNode
} from "../../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../../../core/shared/dto/object/request/object-request-relation";
import {ContractService} from "../../../../../service/api/contract.service";
import {DtoList} from "../../../../../../../core/shared/dto/dto.list";
import {ObjectIdentifier} from "../../../../../../../core/shared/basic/object-identifier";
import {DtoDetail} from "../../../../../../../core/shared/dto/dto.detail";


@Component({
    selector: 'cm-contract-object-base-component',
    template: '',
    standalone: false
})
export class ContractObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    @Input() transientDto: ContractDto | DtoDetail;
    @Input() isOverlay: boolean = false;

    @Output() onTicketsCount: EventEmitter<MvsObjectCount> = new EventEmitter<MvsObjectCount>();
    @Output() onWorkflowsCount: EventEmitter<MvsObjectCount> = new EventEmitter<MvsObjectCount>();

    @Input() dto: ContractDto | DtoDetail;
    ticketIndicatorFilterCriteria: FilterCriteria[];
    workflowObjectRequestList: ObjectRequestList;
    contractIdentifier: ObjectIdentifier;
    @Input() importObjectContext: DtoImportObjectContext;
    @Output() onTicketCreate: EventEmitter<boolean> = new EventEmitter<boolean>();
    navigationItems: NavigationItem[] = [
        {
            label: 'standard',
            action: 'standard',
            tooltip: 'Standard',
            icon: 'fa-regular fa-house',
            toggleable: false,
            default: true
        },

        {
            label: 'documentUpload',
            action: 'documentUpload',
            tooltip: 'Dokumente',
            icon: 'fa-regular fa-paperclip-vertical',
            toggleable: false,
            default: false
        },
        {
            label: 'notifications',
            action: 'notifications',
            tooltip: 'Kommunikation',
            icon: 'fa-regular fa-comments',
            toggleable: false,
            default: false
        },
        {
            label: 'addTicket',
            action: 'addTicket',
            tooltip: 'Ticket erstellen',
            icon: 'pi pi-plus',
            toggleable: true,
            default: false,
            customFunction: () => this.customCreateFunction()
        },
        {
            label: 'genericTickets',
            action: 'genericTickets',
            tooltip: 'Ticket Übersicht',
            icon: 'fa-regular fa-ticket',
            toggleable: false,
            default: false
        },

        {
            label: 'objects',
            action: 'objects',
            tooltip: 'Objekte/ Personen',
            icon: 'fa-regular fa-rectangle-vertical-history',
            toggleable: false,
            default: false
        },
        {
            label: 'externalData',
            action: 'externalData',
            tooltip: 'Externe Vertragsdaten',
            icon: 'fa-regular fa-database',
            toggleable: false,
            default: false
        },
        {
            label: 'coverages',
            action: 'coverages',
            tooltip: 'Deckungen',
            icon: 'fa-regular fa-shield-halved',
            toggleable: false,
            default: false
        },
        {
            label: '',
            action: '',
            divider: true,
            default: false
        },
        // {
        //     label: 'genericWorkflows',
        //     action: 'genericWorkflows',
        //     tooltip: 'General Workflows',
        //     icon: ' fa-regular fa-sharp-duotone fa-arrow-progress text-yellow-500',
        //     toggleable: false,
        //     default: false
        // },
        {
            label: 'calculator',
            action: 'calculator',
            tooltip: 'Rechner',
            icon: 'fa-solid fa-calculator text-yellow-500',
            toggleable: false,
        },

    ];




    constructor(
        protected route: ActivatedRoute,
        protected navigationService: MvsObjectNavigationService,
        protected processService: WfProcessService,
        protected observerService: ObserverService,
        protected contractService: ContractService) {
        super(route);
    }


    customCreateFunction(){
        this.onTicketCreate.emit(true);
    }



    ngOnInit() {

        if (this.navigationItems?.length) {
            this.activeNavigationItem = this.navigationItems.find(item => item.default == true);
            this.onNavigationItems.emit(this.navigationItems);
        }

        this.contractIdentifier = this.createContractIdentifier(this.dto);

        super.ngOnInit();

        this.navigationService.setNavigationProvider(new MvsObjectNavigationProviderGeneric());
        this.setGeneralTabsData();

        this.refreshComponent();


    }

    refreshComponent() {
        this.getRetrieveObjectObservable().subscribe(response => {
            this.dto = response.entries[0];
            this.contractIdentifier = this.createContractIdentifier(this.dto);
            this.initialized = true;
        });
    }


    setGeneralTabsData() {

        this.ticketIndicatorFilterCriteria = [
            FilterCriteria.create("referenceCustomer", FilterCriteria.cOperatorEqual, this.dto?.['joinCurrentMainCustomer']?.id ),
        ];

        this.workflowObjectRequestList = this.processService.getRequestForProcessForObjectViaAlias(
            this.objectIdentifier.objectType,
            this.objectIdentifier.objectId,
            true
        );
    }

    protected getRetrieveObjectObservable(): Observable<DtoList<ContractDto>> {

        const dtoRequest: ObjectRequestList = new ObjectRequestList(
            false,
            [FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            []);

        dtoRequest.objectRequestComplex = ObjectRequestComplex.build(
            false,
            false,
            ObjectRequestComplexNode.createSimpleAttributeNode('contractType'),
            // ObjectRequestComplexNode.createRelationNode("joinCurrentMainPartner", ObjectRequestRelation.createJoin("+currentMainPartner")),
            ObjectRequestComplexNode.createSimpleAttributeNode("partner"),
            ObjectRequestComplexNode.createSimpleAttributeNode("partnerLink"),
            ObjectRequestComplexNode.createRelationNode("joinCurrentMainCustomer", ObjectRequestRelation.createJoin("+currentMainCustomer"))
                .addNodes(ObjectRequestComplexNode.createRelationNode("personDto", ObjectRequestRelation.createJoin("person"))),
            ObjectRequestComplexNode.createRelationNode("contractInsurableObject", ObjectRequestRelation.createJoin("ci.ContractInsurableObject#contract")).addNodes(
                ObjectRequestComplexNode.createSimpleAttributeNode("insurableObject").addNodes(
                    ObjectRequestComplexNode.createSimpleAttributeNode("type")
                )
            )
        );
        return this.contractService.list(dtoRequest);
    }

    handleTicketsCount(event: MvsObjectCount) {
        this.onTicketsCount.emit(event);
    }

    handleWorkflowsCount(event: MvsObjectCount) {
        this.onWorkflowsCount.emit(event);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
        this.refreshComponent();
    }

    createContractIdentifier(dto: DtoDetail) {
        return new ObjectIdentifier('cm.Contract', dto?.id);
    }

}
